import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Careers.css';
import { FaUtensils, FaPaintBrush } from 'react-icons/fa';

function Careers() {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);
    const { t } = useLanguage();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const jobRoles = [
        {
            id: 'kitchen',
            icon: <FaUtensils />,
            key: 'kitchen',
        },
        {
            id: 'confectioner',
            icon: <FaPaintBrush />,
            key: 'confectioner',
        },
    ];

    return (
        <div className="careers-section" id="careers" ref={sectionRef}>
            <div className="careers-container">
                <div className={`careers-header ${isVisible ? 'visible' : ''}`}>
                    <h2 className="section-title">{t('careers.title')}</h2>
                    <p className="section-subtitle">{t('careers.subtitle')}</p>
                </div>

                <div className="careers-grid">
                    {jobRoles.map((role, index) => (
                        <div
                            key={role.id}
                            className={`career-card ${isVisible ? 'visible' : ''}`}
                            style={{ transitionDelay: `${index * 0.2}s` }}
                        >
                            <div className="career-icon">{role.icon}</div>
                            <h3 className="career-role-title">{t(`careers.roles.${role.key}.title`)}</h3>

                            <div className="career-footer">
                                <div className="career-actions">
                                    <a
                                        href={`mailto:mayasflavours@gmail.com?subject=Job Application - ${t(`careers.roles.${role.key}.title`)}`}
                                        className="apply-button"
                                    >
                                        {t('careers.applyNow')}
                                    </a>
                                    <a href="tel:+35797797754" className="call-button">
                                        97 797754
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className={`careers-footer-info ${isVisible ? 'visible' : ''}`}>
                    <p>
                        {t('careers.contactToApply')} <strong>mayasflavours@gmail.com</strong>
                    </p>
                    <p>
                        {t('careers.callUs')} <strong>97 797754</strong>
                    </p>
                </div>
            </div>

            {/* Background Decoration */}
            <div className="careers-bg-decoration deco-1"></div>
            <div className="careers-bg-decoration deco-2"></div>
        </div>
    );
}

export default Careers;

